export default "__VITE_ASSET__BITQNCYA__"